import { useEffect, useState } from "react";
import axios from "axios";
import { History, Loader2 } from "lucide-react";

import { API } from "@/lib/api";

const ActivityPanel = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/activity`, { withCredentials: true })
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, []);

  if (items === null) {
    return (
      <div className="flex justify-center py-24">
        <Loader2 className="h-8 w-8 animate-spin text-navy" />
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="mt-10 flex flex-col items-center rounded-3xl border border-gray-100 bg-white py-20 text-center">
        <History className="h-10 w-10 text-gray-300" />
        <p className="mt-4 font-heading text-lg font-bold text-ink">No activity yet</p>
        <p className="mt-1 text-sm text-fog">Admin actions will be recorded here.</p>
      </div>
    );
  }

  return (
    <div data-testid="activity-panel" className="mt-6 overflow-hidden rounded-3xl border border-gray-100 bg-white shadow-sm">
      {items.map((a, i) => (
        <div
          key={a.id}
          data-testid="activity-row"
          className={`flex flex-wrap items-center gap-x-4 gap-y-1 px-6 py-4 ${
            i % 2 ? "bg-mist/50" : ""
          }`}
        >
          <span className="font-heading text-sm font-bold text-ink">{a.action}</span>
          {a.detail && <span className="text-sm text-fog">{a.detail}</span>}
          <span className="ml-auto text-xs text-fog">
            {a.actor} ·{" "}
            {new Date(a.created_at).toLocaleString("en-IN", {
              day: "numeric",
              month: "short",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        </div>
      ))}
    </div>
  );
};

export default ActivityPanel;
